import { Link } from "react-router"
import { BuildingIcon } from "../icons"
import { ArrowUpRight } from "../layout"
import { SchoolGrid } from "../school-cards"

export function PartnerSchools() {
  return (
    <section className="bg-cream-50 pb-24">
      <div className="public-container">
        <span className="inline-flex items-center gap-2.5 rounded-full border border-ink/10 bg-cream-100 px-4 py-1.5 text-sm font-medium text-ink">
          <BuildingIcon />
          Partner Schools
        </span>

        <div className="mt-10 max-w-[928px]">
          <h2 className="font-display text-[36px] font-bold leading-tight text-ink sm:text-[48px] sm:leading-none">
            Real classrooms. <span className="text-forest-700">Real futures.</span>
          </h2>
          <p className="mt-4 max-w-[928px] text-lg text-ink">
            We start our journey with a dedicated partner, fostering growth with purpose. Schools contact us, and we choose those that will fully support our scholars throughout their journey.
          </p>
          <Link
            to="/partner-schools"
            className="mt-8 inline-flex items-center gap-3 rounded-full bg-forest-950 py-1.5 pl-5 pr-1.5 text-base font-semibold text-white transition-colors hover:bg-forest-800"
          >
            See partner schools
            <span className="grid h-10 w-10 place-items-center rounded-full bg-white text-forest-950">
              <ArrowUpRight />
            </span>
          </Link>
        </div>

        <div className="mt-10">
          <SchoolGrid />
        </div>
      </div>
    </section>
  )
}
